/* ========================================================================== 
   Nootrópicos México v70.9.2 — Product regression runtime
   ========================================================================== */
(function () {
  "use strict";

  var root = document.documentElement;
  var productMedia = "(min-width: 990px)";
  var productWidths = [1024, 1280, 1600, 2048];

  function isResizableShopifyImage(source) {
    if (!source || source.indexOf("/assets/") !== -1) return false;
    try {
      var url = new URL(source, window.location.href);
      return (
        url.hostname.indexOf("cdn.shopify.com") !== -1 ||
        url.pathname.indexOf("/cdn/shop/") !== -1
      );
    } catch (error) {
      return false;
    }
  }

  function imageAtWidth(source, width) {
    var url = new URL(source, window.location.href);
    url.searchParams.set("width", String(width));
    return url.toString();
  }

  window.nmSetResponsiveProductImage = function (image, source) {
    if (!image || !source) return;

    if (!isResizableShopifyImage(source)) {
      image.setAttribute("src", source);
      image.removeAttribute("srcset");
      return;
    }

    image.setAttribute("src", imageAtWidth(source, 1600));
    image.setAttribute(
      "srcset",
      productWidths
        .map(function (width) {
          return imageAtWidth(source, width) + " " + width + "w";
        })
        .join(", "),
    );
    image.setAttribute(
      "sizes",
      "(max-width: 768px) calc(100vw - 40px), (max-width: 1080px) 50vw, 520px",
    );
    image.setAttribute("data-zoom", imageAtWidth(source, 2048));
  };

  function restoreInitialProductImage() {
    var image = document.querySelector("#ProductPhotoImg, #nmMainProductImg");
    if (!image || image.classList.contains("nm-fasoracetam-product-image")) return;
    window.nmSetResponsiveProductImage(image, image.getAttribute("src"));
  }

  function syncDesktopStickyBar() {
    var sticky = document.getElementById("nmStickyATC");
    if (!sticky || !window.matchMedia) return;

    if (window.matchMedia(productMedia).matches) {
      sticky.classList.add("is-visible", "nm-sticky-atc--desktop");
      root.classList.add("nm-sticky-atc-active");
      window.requestAnimationFrame(function () {
        var height = Math.ceil(sticky.getBoundingClientRect().height);
        if (height) root.style.setProperty("--nm-sticky-atc-height", height + "px");
      });
      window.dispatchEvent(
        new CustomEvent("nm:sticky-atc-change", { detail: { visible: true } }),
      );
    } else {
      var sentinel = document.getElementById("nmATCSentinel");
      var rect = sentinel && sentinel.getBoundingClientRect();
      var intersectsViewport = Boolean(
        rect && rect.bottom > 0 && rect.top < window.innerHeight,
      );
      var shouldShow = !intersectsViewport;
      sticky.classList.remove("nm-sticky-atc--desktop");
      sticky.classList.toggle("is-visible", shouldShow);
      sticky.style.display = shouldShow ? "flex" : "none";
      root.classList.toggle("nm-sticky-atc-active", shouldShow);
    }
  }

  function init() {
    restoreInitialProductImage();
    syncDesktopStickyBar();

    var resizeFrame = 0;
    window.addEventListener(
      "resize",
      function () {
        if (resizeFrame) return;
        resizeFrame = window.requestAnimationFrame(function () {
          resizeFrame = 0;
          syncDesktopStickyBar();
        });
      },
      { passive: true },
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
